export default "__VITE_ASSET__pNwmoblp__"